"use strict";
import { jsx } from "react/jsx-runtime";
import React from "react";
import $ from "jquery";
import _ from "underscore";
import "../api/api";
import "select2";
import DOMPurify from "dompurify";
function formatContact(contact) {
  return {
    id: contact.email,
    text: contact.email,
    contact
  };
}
function itemTemplate(item) {
  if (item.contact) {
    let renderField2 = function(field) {
      return `<div title='${field.field}'>${field.value}</div>`;
    };
    var renderField = renderField2;
    const fieldsToShow = [
      { field: "Name", value: item.contact.name },
      { field: "Email", value: item.contact.email },
      { field: "Title", value: item.contact.title }
    ].filter((x) => x.value);
    const fields = fieldsToShow.map(renderField2).join("");
    return `<div style="display: flex; gap: 25px;">${fields}</div>`;
  }
  return item.text;
}
function formattedRecipients(props) {
  return _.map(props.recipients || [], (email) => ({ email }));
}
function localResults(props) {
  return [...formattedRecipients(props), ...contactsWithoutRecipients(props)];
}
function matchedLocalResults(props, term) {
  function matchesTerm(text) {
    return text && text.toLowerCase().includes(term.toLowerCase());
  }
  function itemMatchesTerm(item) {
    return !term || matchesTerm(item.email) || matchesTerm(item.title) || matchesTerm(item.name);
  }
  return localResults(props).filter(itemMatchesTerm);
}
function contactsWithoutRecipients(props) {
  return _.reject(props.contacts || [], (contact) => {
    return (props.recipients || []).indexOf(contact.email) >= 0;
  });
}
const EmailTypeAhead = React.createClass({
  componentDidMount: function() {
    this.loadSelect();
  },
  render: function() {
    return /* @__PURE__ */ jsx(
      "select",
      {
        "data-component": "EmailTypeAhead",
        ref: "recipients",
        multiple: true,
        style: { display: "none" }
      }
    );
  },
  changed: function() {
    this.props.onChange(this.$element().val() || []);
  },
  $element() {
    return $(this.refs.recipients);
  },
  loadSelect: function() {
    const $element = this.$element();
    $element.select2({
      ajax: {
        url: "/api/contacts/search",
        dataType: "json",
        delay: 100,
        data: function(term) {
          return {
            query: term
          };
        },
        processResults: (data, params) => {
          params.page = params.page || 1;
          const localResults2 = matchedLocalResults(this.props, params.term);
          const remoteResults = params.term ? data.contacts : [];
          const results = [
            ..._.sortBy(localResults2, "email"),
            ..._.sortBy(remoteResults, "email")
          ].map(formatContact);
          return { results };
        },
        cache: true
      },
      escapeMarkup: (markup) => DOMPurify.sanitize(markup),
      templateResult: itemTemplate,
      tags: true,
      placeholder: "email addresses, comma or space separated"
    });
    if (this.props.selectByDefault) {
      _.each(this.props.recipients, (recipient) => {
        $element.append(
          $("<option>", {
            value: recipient,
            text: recipient
          })
        );
      });
      $element.val(this.props.recipients);
    }
    $element.on("change", this.changed);
    $element.trigger("change");
    $element.on("select2:unselect", this.changed);
    switch (this.props.focusBehavior) {
      case "focus":
        $element.select2("focus");
        break;
    }
  }
});
export default EmailTypeAhead;
